<template>
  <div class="waypoint-navigator">
    <div class="waypoint-navigator__time-indication" :style="timeIndicationStyle"></div>
    <draggable v-model="tags">
      <div v-for="tag in tags" v-bind:key="tag.id" class="waypoint-navigator__track">
        <div class="waypoint-navigator__track-nav" >
          <div>{{tagName(tag)}}</div>
        </div>
        <waypoint-navigator-track :tag="tag" @selectWaypoint="onSelectWaypoint"/>
      </div>
    </draggable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import waypointNavigatorTrack from './waypointNavigatorTrack'
import draggable from 'vuedraggable'
import { metaDataFormDefaultsFor } from '../../editor/metadataFormFields'

export default {
  name: 'waypointNavigator',

  components: {
    'waypoint-navigator-track': waypointNavigatorTrack,
    'draggable': draggable
  },

  props: {
    filteredTags : {
      type: Array,
      default: function () {
        return []
      }
    }
  },

  data: function () {
    return {
      bb: null
    }
  },

  computed: {
    ...mapGetters(['videoDuration', 'currentTime']),

    timeIndicationStyle: function () {
      const widthPercentage = this.currentTime / this.videoDuration
      let width = 0

      if (this.bb) {
        width = (widthPercentage * (this.bb.width - 90))
      }

      return {
        width: `${width}px`
      }
    },

    tags: {
      get: function () {
        const tags = this.filteredTags
        return tags
      },

      set: function (value) {
        this.$store.commit('updateTags', value)
      }
    }
  },

  mounted() {
    this.bb = document.querySelector('.waypoint-navigator') && document.querySelector('.waypoint-navigator').getBoundingClientRect()
  },

  methods: {
    onSelectWaypoint: function (waypoint) {
      this.$emit('selectWaypoint', waypoint)
    },

    tagName: function (tag) {
      return tag.name !== 'New Tag' ? tag.name : (metaDataFormDefaultsFor(tag.template) || {}).label
    }
  }
}
</script>
